export enum ProjectCritically {
	VERY_HIGH = "VERY_HIGH",
	HIGH = "HIGH",
	MEDIUM = "MEDIUM",
	LOW = "LOW",
	MISSING_VALUE = "MISSING_VALUE",
}
